import classNames from 'classnames';

import EllipseBlur from 'app/components/common/EllipseBlur';
import { IconLogoApp, IconAppStore, IconRuStore } from 'app/components/sprites';
import StretchAnimation from 'app/components/common/StretchAnimation';

import { IMobileAppServicesTheme } from './themes';

interface IMobileAppServicesContentProps {
  theme: IMobileAppServicesTheme;
  googlePlay?: string | null;
  appStore?: string | null;
}

export default function MobileAppServicesContent({
  theme,
  googlePlay,
  appStore
}: IMobileAppServicesContentProps) {
  const { bgColor, textColor, borderColor, iconFillcolor, showBlur } = theme;
  return (
    <section
      className={classNames(
        'relative wrapper-main pt-32 pb-10 md:py-36 xl:py-48 flex flex-col md:items-center gap-10 xl:gap-16 overflow-hidden',
        bgColor
      )}
    >
      {showBlur && (
        <div
          className={classNames(
            'absolute w-[900px] md:w-[1100px] 2xl:w-[80%] top-[0%] left-0 -translate-x-[50%] pointer-events-none opacity-50 lg:opacity-100'
          )}
        >
          <EllipseBlur />
        </div>
      )}

      <div className="flex flex-col justify-center items-center gap-10 xl:gap-16 w-full relative">
        <div className="w-[60%] md:w-[60%] xl:w-[30%]">
          <div className="relative pb-[32%] overflow-hidden">
            <div className="abs-center w-[160%]">
              <div className="relative pb-16/9">
                <StretchAnimation play={true} loop={true} color="brown" />
              </div>
            </div>
          </div>
        </div>

        <div className="uppercase text-outlined text-xl md:text-4xl xl:text-7xl text-brown text-center">
          <div>Мобильное</div>
          <div>приложение</div>
        </div>
      </div>
      <div className="md:grid md:grid-cols-2 md:w-full relative">
        <div
          className={classNames(
            'flex flex-col md:flex-row gap-15 justify-center items-center w-full md:w-fit',
            'md:p-2 xl:p-3 md:border md:rounded xl:rounded-3xl md:col-start-2 md:-ml-[29px] xl:-ml-[43px]',
            borderColor
          )}
        >
          <div className="rounded-md xl:rounded-2xl bg-graphite-dark w-10 xl:w-15 h-10 xl:h-15 flex flex-col justify-center items-center">
            <IconLogoApp
              className={classNames(
                'w-7 xl:w-10 h-7 xl:h-10 pr-1',
                iconFillcolor
              )}
            />
          </div>
          <div className="flex flex-col md:flex-row gap-1.5 md:gap-4 w-full md:w-auto md:pr-5 xl:pr-11">
            {!!googlePlay && (
              <a
                href={googlePlay}
                target="_blank"
                rel="nofollow"
                className={classNames(
                  'py-5 md:py-0 w-full flex justify-center items-center gap-1.5',
                  'rounded border md:border-none',
                  borderColor,
                  textColor
                )}
              >
                <IconRuStore className={classNames('fill-current w-4 h-4')} />
                <span className="text-h2 whitespace-nowrap">rustore</span>
              </a>
            )}

            {!!appStore && (
              <a
                href={appStore}
                target="_blank"
                rel="nofollow"
                className={classNames(
                  'py-5 md:py-0 w-full flex justify-center items-center gap-1.5',
                  'rounded border md:border-none',
                  borderColor,
                  textColor
                )}
              >
                <IconAppStore className={classNames('fill-current w-4 h-4')} />
                <span className="text-h2 whitespace-nowrap">app store</span>
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
